module.exports = ["Gravity","Hydraulic Press","Mechanical","Mechanical Press","Odmaxw","Power","Upsetter"]


//////////////////
// WEBPACK FOOTER
// ./src/config/process.json
// module id = 5426
// module chunks = 1